export default "__VITE_ASSET__BP0I3CJx__"